import type { Theme } from '../types';
import type { Components } from '@mui/material/styles';

export const MuiCardActions = {
  styleOverrides: { root: { padding: '8px 16px 16px' } },
} satisfies Components<Theme>['MuiCardActions'];
